import { Typography, makeStyles, Theme, createStyles, ButtonBase } from "@material-ui/core";
import { ReactNode } from "react";
import { Clear as ClearIcon } from "~components/Icons";

export type CustomerSelectorProps = {
  current?: {
    name: string | ReactNode;
  };
  onClear?: () => void;
};

export const CustomerSelector = ({ current, onClear }: CustomerSelectorProps) => {
  const classes = useStyles();

  return (
    <>
      <div className={classes.root}>
        {/* TODO dropdown here */}
        {current && (
          <div className={classes.current}>
            <Typography className={classes.name}>{current.name}</Typography>
            {onClear && (
              <ButtonBase className={classes.clear} onClick={() => onClear()}>
                <ClearIcon />
              </ButtonBase>
            )}
          </div>
        )}
      </div>
    </>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      alignItems: "center",
    },
    current: {
      display: "flex",
      marginRight: theme.spacing(2),
    },
    name: {
      color: theme.palette.primary.main,
      textTransform: "uppercase",
      fontSize: 12,
      fontWeight: 700,
      lineHeight: "19px",
      letterSpacing: "1px",
    },
    clear: {
      marginLeft: 4,
    },
  }),
);
